export default {
	title: "Retornos",
	newReturn: "Nuevo Retorno",
	fulfill: "Cumplir",
	fulfilled: "Cumplido",
	pending: "Pendiente",
	debit: "Debitar",
	delete: "Eliminar",
	deleteConfirmTitle: "¿Eliminar retorno?",
	deleteConfirmText: "Esta acción no se puede deshacer.",
	noReturns: "Ningún retorno",
	returnType: {
		RESERVATION: "Reserva",
		NEXT_RITUAL: "Próximo Ritual",
		SPECIFIC_RITUAL: "Ritual Específico",
		SPECIFIC_DATE: "Fecha Específica",
		COUNTER: "Contador",
		INDEFINITE: "Indefinido",
	},
	fields: {
		person: "Persona",
		type: "Tipo",
		target: "Destino",
		status: "Situación",
		notes: "Observaciones",
	},
	form: {
		returnTypeRequired: "El tipo de retorno es obligatorio",
		targetAttendanceTypeRequired: "Informe el tipo de ficha",
	},
	messages: {
		created: "Retorno creado con éxito",
		fulfilled: "Retorno cumplido",
		debited: "Retorno debitado: {remaining}/{total}",
		deleted: "Retorno eliminado",
		createError: "Error al crear retorno",
		debitError: "Error al debitar retorno",
		deleteError: "Error al eliminar retorno",
		fulfillError: "Error al cumplir retorno",
		loadError: "Error al cargar retornos",
	},
};
